<template>
  <div>
    <span class="component-label">{{'&lt;' + $options.name + ' />'}}</span>
    <div class="page-content">
      Account Dashboard content
    </div>
  </div>
</template>
<script>
export default {
  name: 'AccountDashboardPage'
}
</script>



// WEBPACK FOOTER //
// src/pages/account/AccountDashboardPage.vue